<template>
    <section class="customer">
        <div class="layout-banner">
            <div class="banner">
                <div class="banner-text w-1200">
                    <div class="big-text animate__animated animate__zoomIn">数字保险的智能中台</div>
                    <div class="sm-text animate__animated animate__fadeIn">科技赋能产业，深耕行业场景，产品、风控、服务三位一体铸造保险科技中台“新动力”</div>
                </div>
            </div>
            <Nav :activeIndex='"3"'></Nav>
        </div>
        <div class="customer-container w-1200">
             <el-tabs tab-position="left">
                <el-tab-pane label="最新案例">
                    <div class="customer-list">
                        <div class="customer-card-logo"><img src="../../assets/pet.png" alt=""></div>
                        <div class="customer-card-content">
                            <div class="customer-card-desc">
                                <div class="customer-card-title-box">
                                    <h3 class="customer-card-title">**宠物医院集团<span class="partner-category">宠物</span></h3>
                                </div>
                                <p>
                                    全球1300多家分院，员工总数15000多名，覆盖50多个城市，执业兽医1200多名;<br>
                                    经营范围涵盖：宠物医疗保健、宠物美容造型、宠物留置护理、宠物食品及用品等;<br>
                                    先后被评为 “2016年度中国经济新领军企业”、“2017创新中国社会责任典范企业奖”、“2017诚信中国·优秀示范单位”、“2017中国改革创新先锋企业”等;<br>
                                    医院配备有核磁共振(MRI)、电子计算机断层扫描(CT)、动物专用血液透析仪、荧光定量PCR仪、内窥镜、超声乳化仪、手术显微镜及高清示教系统、数字化直接成像系统(DR)、彩色超声诊断仪、呼吸麻醉机等设备，各区域中心医院还配置有药敏实验室和病理实验室，基本上可以完成小动物常见临床疾病的诊断和治疗;<br>

                                </p>
                             </div>
                             <h5>使用产品</h5>
                             <ul class="mt20">
                                 <li><img src="../../assets/icon/pet1.png" alt=""><br>智能鼻纹识别系统</li>
                                 <li><img src="../../assets/icon/pet2.png" alt=""><br>智能专家理赔系统</li>
                                 <li><img src="../../assets/icon/pet3.png" alt=""><br>大数据风控系统</li>
                             </ul>
                         </div>
                    </div>
                    <div class="customer-list">
                        <div class="customer-card-logo"><img src="../../assets/phone.png" alt=""></div>
                        <div class="customer-card-content">
                            <div class="customer-card-desc">
                                <div class="customer-card-title-box">
                                    <h3 class="customer-card-title">**科技 知名手机国代商<span class="partner-category">手机</span></h3>
                                </div>
                                 <p>
                                    员工超过1000人，年维修量超150万台，年收入超过3亿元；<br>
                                    专注手机售后23年，国内网络覆盖广、规模大、实力强的手机全售后服务商,与国内三大运营商建立战略合作关系;<br>
                                    拥有先进的全国在线售后管理系统（K9）以及强大的供应链运作能力,在全国自建22家分公司以及70多家终端服务门店,服务网络覆盖全国T1-T4城市；<br>
                                    Apple、华为、三星、小米、美图、联想、魅族、锤子、酷派、ivivi、诺基亚、夏普、一加、海信、飞利浦、天语等国内外众多知名移动通信品牌指定的专业售后维修服务机构；<br>
                                </p>
                             </div>
                             <h5>使用产品</h5>
                             <ul class="mt20">
                                 <li><img src="../../assets/icon/phone1.png" alt=""><br>智慧零售系统</li>
                                 <li><img src="../../assets/icon/phone2.png" alt=""><br>业绩可视平台</li>
                                 <li><img src="../../assets/icon/phone3.png" alt=""><br>佣金管理平台</li>
                             </ul>
                         </div>
                    </div>
                    <div class="customer-list">
                        <div class="customer-card-logo"><img src="../../assets/jiadian.png" alt=""></div>
                        <div class="customer-card-content">
                            <div class="customer-card-desc">
                                <div class="customer-card-title-box">
                                    <h3 class="customer-card-title">**集成灶<span class="partner-category">家电</span></h3>
                                </div>
                                <p>
                                    “五星级售后服务认证”和“五星级服务口碑认证”双认证的企业;<br>
                                    一家始终专注于厨房电器的研发、制造，旨在彻底解决厨房油烟问题的现代化高科技集团;<br>
                                    拥有核心科技“低空全吸·智能全净吸系统”，拥有国家专利84项;<br>
                                    2011年4月开出第一家门店，截至2018年6月，共有1137家专卖店，销售额30亿（2020年）;<br>
                                </p>
                             </div>
                             <h5>使用产品</h5>
                             <ul class="mt20">
                                 <li><img src="../../assets/icon/phone1.png" alt=""><br>智慧零售系统</li>
                                 <li><img src="../../assets/icon/phone2.png" alt=""><br>业绩可视平台</li>
                                 <li><img src="../../assets/icon/phone3.png" alt=""><br>佣金管理平台</li>
                                 <li><img src="../../assets/icon/phone4.png" alt=""><br>智能理赔系统</li>
                             </ul>
                         </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="手机保险">
                    <div class="customer-list">
                        <div class="customer-card-logo"><img src="../../assets/phone.png" alt=""></div>
                        <div class="customer-card-content">
                            <div class="customer-card-desc">
                                <div class="customer-card-title-box">
                                    <h3 class="customer-card-title">**科技 知名手机国代商<span class="partner-category">手机</span></h3>
                                </div>
                                <p>
                                    员工超过1000人，年维修量超150万台，年收入超过3亿元；<br>
                                    专注手机售后23年，国内网络覆盖广、规模大、实力强的手机全售后服务商,与国内三大运营商建立战略合作关系;<br>
                                    拥有先进的全国在线售后管理系统（K9）以及强大的供应链运作能力,在全国自建22家分公司以及70多家终端服务门店,服务网络覆盖全国T1-T4城市；<br>
                                    Apple、华为、三星、小米、美图、联想、魅族、锤子、酷派、ivivi、诺基亚、夏普、一加、海信、飞利浦、天语等国内外众多知名移动通信品牌指定的专业售后维修服务机构；<br>
                                </p>
                             </div>
                             <h5>使用产品</h5>
                             <ul class="mt20">
                                 <li><img src="../../assets/icon/phone1.png" alt=""><br>智慧零售系统</li>
                                 <li><img src="../../assets/icon/phone2.png" alt=""><br>业绩可视平台</li>
                                 <li><img src="../../assets/icon/phone3.png" alt=""><br>佣金管理平台</li>
                             </ul>
                         </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="宠物保险">
                    <div class="customer-list">
                        <div class="customer-card-logo"><img src="../../assets/pet.png" alt=""></div>
                        <div class="customer-card-content">
                            <div class="customer-card-desc">
                                <div class="customer-card-title-box">
                                    <h3 class="customer-card-title">**宠物医院集团<span class="partner-category">宠物</span></h3>
                                </div>
                                <p>
                                    全球1300多家分院，员工总数15000多名，覆盖50多个城市，执业兽医1200多名;<br>
                                    经营范围涵盖：宠物医疗保健、宠物美容造型、宠物留置护理、宠物食品及用品等;<br>
                                    先后被评为 “2016年度中国经济新领军企业”、“2017创新中国社会责任典范企业奖”、“2017诚信中国·优秀示范单位”、“2017中国改革创新先锋企业”等;<br>
                                    医院配备有核磁共振(MRI)、电子计算机断层扫描(CT)、动物专用血液透析仪、荧光定量PCR仪、内窥镜、超声乳化仪、手术显微镜及高清示教系统、数字化直接成像系统(DR)、彩色超声诊断仪、呼吸麻醉机等设备，各区域中心医院还配置有药敏实验室和病理实验室，基本上可以完成小动物常见临床疾病的诊断和治疗;<br>

                                </p>
                             </div>
                             <h5>使用产品</h5>
                             <ul class="mt20">
                                 <li><img src="../../assets/icon/pet1.png" alt=""><br>智能鼻纹识别系统</li>
                                 <li><img src="../../assets/icon/pet2.png" alt=""><br>智能专家理赔系统</li>
                                 <li><img src="../../assets/icon/pet3.png" alt=""><br>大数据风控系统</li>
                             </ul>
                         </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="家电保险">
                    <div class="customer-list">
                        <div class="customer-card-logo"><img src="../../assets/jiadian.png" alt=""></div>
                        <div class="customer-card-content">
                            <div class="customer-card-desc">
                                <div class="customer-card-title-box">
                                    <h3 class="customer-card-title">**集成灶<span class="partner-category">家电</span></h3>
                                </div>
                                <p>
                                    “五星级售后服务认证”和“五星级服务口碑认证”双认证的企业;<br>
                                    一家始终专注于厨房电器的研发、制造，旨在彻底解决厨房油烟问题的现代化高科技集团;<br>
                                    拥有核心科技“低空全吸·智能全净吸系统”，拥有国家专利84项;<br>
                                    2011年4月开出第一家门店，截至2018年6月，共有1137家专卖店，销售额30亿（2020年）;<br>
                                </p>
                             </div>
                             <h5>使用产品</h5>
                             <ul class="mt20">
                                 <li><img src="../../assets/icon/phone1.png" alt=""><br>智慧零售系统</li>
                                 <li><img src="../../assets/icon/phone2.png" alt=""><br>业绩可视平台</li>
                                 <li><img src="../../assets/icon/phone3.png" alt=""><br>佣金管理平台</li>
                                 <li><img src="../../assets/icon/phone4.png" alt=""><br>智能理赔系统</li>
                             </ul>
                         </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <Footer></Footer>
        <Cornerbar></Cornerbar>
    </section>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import Cornerbar from '@/components/Cornerbar'
export default {
  components: {
    Nav,
    Footer,
    Cornerbar
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "~@/styles/variable.scss";
.customer{
    .layout-banner{
        position: relative;
        height: 580px;
        .el-carousel__item.is-active{
            .banner-text{
              // animation-duration: 1.5s;
              // animation-name: zoomIn;
              .big-text{
                animation-name: zoomIn;
              }
              .sm-text{
                animation-name: fadeIn;
              }
            }
        }
    }
    .banner{
        background: url(../../assets/banner4.png) 100% no-repeat;
        position: absolute;
        top: 0;
        width: 100%;
        height: 580px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-position: center center;
        background-color: #0b0f1a;
        &.banner4{
          background-image: url(../../assets/banner4.png);
        }
        &.banner9{
          background-image: url(../../assets/banner9.png);
        }
        .banner-text{
            font-family: 'SourceHanSansCN-Regular';
            margin: 0 auto;
            padding-top: 189px;
            animation-duration: 2.5s;
            text-align: center;
            .big-text{
                color: #fff;
                height: 67px;
                font-size: 56px;
                line-height: 67px;
                letter-spacing: 1px;
                font-weight: bold;
                animation-duration: 1.8s;
                background-color: #fff;
                // background-image: -webkit-gradient(linear, 0 0, 0 bottom, from(rgba(255, 255, 255, 1)), to(#7FC1F9));
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                // animation-name: none;
            }
            .sm-text{
                margin-top: 48px;
                line-height: 30px;
                font-size: 18px;
                letter-spacing: 1px;
                color: #E5E5E5;
                font-weight:400;
                // animation-name: none;
            }
        }
    }
    .customer-container{
        margin: 0 auto;
        padding: 30px 15px;
        padding-top: 64px;
        .el-tabs__item{
            height: 57px;
            line-height: 57px;
            font-size: 16px;
            text-align: left;
            width: 200px;
        }
        .el-tabs__active-bar{
            height: 57px !important;
        }
        .el-tab-pane{
            margin-left: 65px;
        }
        .customer-list{
            display: flex;
            flex-wrap: wrap;
            // border-top: 1px solid #E0E0E0;
            .customer-card-logo{
                width: 210px;
                padding-top: 35px;
                img{
                    width: 140px;
                    border-radius: 5px;
                    box-shadow:0 0 15px 9px rgba(21, 144, 288, 0.08);
                }

            }
            .customer-card-content{
                width: 650px;
                padding: 25px 0;
                .customer-card-desc{
                    margin-top: 9px;
                    .customer-card-title-box{
                        display: flex;
                        align-items: center;
                        h3.customer-card-title {
                            font-size: 20px;
                            font-weight: bold;
                            margin-bottom: 0;
                            color: #333;
                            .partner-category {
                                color: #827D7C;
                                font-size: 12px;
                                border: 1px solid #827D7C;
                                margin-left: 20px;
                                margin-top: 2px;
                                height: 20px;
                                padding: 0px 4px;
                                text-align: center;
                                box-sizing: border-box;
                                line-height: 18px;
                                font-weight: normal;
                                vertical-align:middle;
                            }
                        }
                    }
                    p{
                        margin: 20px 40px 8px 0;
                        line-height: 26px;
                        font-size: 14px;
                        color: #666;
                    }
                }
                ul{
                    display: flex;
                    // justify-content: space-between;
                    align-items: center;
                    text-align: center;
                    li{
                        font-size: 13px;
                        color: #3E70BF;
                        margin-right: 40px;
                        font-weight: 500;
                        // font-family: "PingFangSC-Medium";
                        img{
                            width: 26px;
                            margin-bottom: 5px;
                        }
                    }
                }
                h5{
                    color: #333;
                    font-size: 16px;
                    font-weight: bold;
                    margin-top: 30px;
                }
            }
        }
    }
}
</style>
